import { useMemo } from "react"

export const useJsonMemorizedValue = <S>(value: S): S => {
	const isJsonSerializable = value && !["string", "boolean", "number"].includes(typeof value)
	const comparableValue = isJsonSerializable ? JSON.stringify(value) : value

	// eslint-disable-next-line react-hooks/exhaustive-deps
	return useMemo(() => value, [comparableValue])
}
